import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { AltPrimaryButton, TextButton } from 'scy/buttons';
import { H1, H3, H4, Paragraph, SmallAlt } from 'scy/text';
import AccountLinkForm from './accountLinkForm';
import styles from './styles.mod.scss';
import padding from 'scy/padding.mod.scss';
import Modal from 'scy/Modal';
import margin from 'scy/margin.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';

export default function AccountLinkModal() {
  const user = useSelector(state => state.login.user || {});
  const [isOpen, setIsOpen] = useState(true);
  const [accepted, setAccepted] = useState(false);
  function onModalClose() {
    setIsOpen(true);
    setAccepted(false);
    console.log("invoked");
  }
  return (
    <div
      className={classnames(styles.container, styles.background, padding.lg)}
    >
      <H1 className={classnames(styles.heading, padding.bottom_sm)}>
        meet
        <br />
        emjay
      </H1>
      <H3 className={classnames(padding.bottom_sm, styles.capitalize)}>
        we deliver cannabis now.
      </H3>
      <Paragraph
        className={classnames(padding.bottom_md, styles.gtAmericaReg)}
        colorClass={styles.colorWhite}
      >
        The people have spoken. Not only do you all want your alcohol delivered,
        but you also want your cannabis delivered. Genius. And so deliver, we
        will. Quick FYI, though: according to “the law,” alcohol and cannabis
        cannot be purchased together, so you’ll need to check out separately for
        alcohol (with Saucey) and cannabis (on Emjay’s website). You’ll have
        separate couriers, too. But we promise it’s so simple that someone who
        is—in theory—significantly cross faded can do it, because you can use
        your Saucey account to log in with Emjay. Easy as that.
      </Paragraph>
      <AltPrimaryButton onClick={() => setAccepted(true)}>
        sign in with saucey
      </AltPrimaryButton>
      <TextButton
        noUnderline
        type="button"
        className={classnames(styles.tipButton, padding.top_md)}
        onClick={() => setIsOpen(false)}
      >
        no thanks, i&apos;m not fun at parties.
      </TextButton>
      {accepted && (
        <Modal
          isOpen={isOpen}
          canClose={true}
          handleClose={() => {
            onModalClose();
          }}
          className={classnames(styles.modal)}
        >
          <div
            className={classnames(
              styles.flexColumn,
              styles.flexCenterCenter,
              padding.md
            )}
          >
            <H4
              className={classnames(
                textCenter,
                styles.gtAmericaReg,
                styles.scyTeal
              )}
              tag="h4"
              marginClass={`${margin.top_sm} ${margin.bottom_0}`}
            >
              Sign in with Saucey
            </H4>
            <br />
            <SmallAlt
              className={classnames(
                margin.bottom_md,
                styles.gtAmericaReg,
                textCenter
              )}
            >
              Use your Saucey login credentials to sign in on Emjay
            </SmallAlt>
            <AccountLinkForm
              initEmail={user.email}
              colorClass={styles.scyTeal}
              onSuccess={data => (window.location = data.redirect_url)}
            />
          </div>
        </Modal>
      )}
    </div>
  );
}
